import { Modal } from 'hljd'

export const zhituibaoModal = data => {
  const { tip, button } = data

  Modal.warning({
    content: tip,
    okText: button,
    onOk: () => {
      window.location.href = '#/localMerchant/creativeCenter'
    }
  })
}
